import { AttachmentFileList, AttachmentFileType } from 'owa-attachment-file-types';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { lazyLogEntitiesFromFilePicker } from 'owa-search-instrumentation';
import { getAttachmentSuggestionsTraceId } from './logAttachMenuData';
import SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import ItemId from 'owa-service/lib/contract/ItemId';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import fetchDataProviderResourceRequest from 'owa-service/lib/factory/fetchDataProviderResourceRequest';
import fetchDataProviderResourceOperation from 'owa-service/lib/operation/fetchDataProviderResourceOperation';
import { trace } from 'owa-trace';

export default async function logEntitiesFromFilePicker(
    files: AttachmentFileList,
    referenceItemId: ItemId
) {
    const sessionSettings = getUserConfiguration().SessionSettings;
    const fileType = [];
    const fileId = [];
    for (let i = 0; i < files.length; i++) {
        const file = files[i];
        fileType.push(file.fileType);
        let id = null;

        if (
            (file.fileType === AttachmentFileType.Cloud ||
                file.fileType === AttachmentFileType.CloudSuggestion ||
                file.fileType === AttachmentFileType.ContextualSuggestion) &&
            file.providerType === AttachmentDataProviderType.OneDrivePro
        ) {
            id = await getSharePointIds(file.providerType, file.location);
        }

        fileId.push(id);
    }
    lazyLogEntitiesFromFilePicker.importAndExecute(
        SubstrateSearchScenario.SuggestedAttachments,
        sessionSettings.UserPuid,
        sessionSettings.ExternalDirectoryTenantGuid,
        getAttachmentSuggestionsTraceId(referenceItemId),
        JSON.stringify(fileType),
        JSON.stringify(fileId)
    );
}

async function getSharePointIds(providerType: AttachmentDataProviderType, url: string) {
    try {
        const base64Value: string = btoa(url);
        const base64EncodedUrl: string =
            'u!' +
            base64Value
                .replace(/^\=+|\=+$/g, '')
                .replace('/', '_')
                .replace('+', '-');
        const schemaHost = new RegExp(/.+?\:\/\/.+?(\/)/g).exec(url)[0];

        const vroomUrl = `${schemaHost}_api/v2.0/shares/${base64EncodedUrl}/?expand=sharepointIds`;

        const fetchRequest = fetchDataProviderResourceRequest({
            ProviderType: providerType,
            Url: vroomUrl,
        });

        const result = await fetchDataProviderResourceOperation(fetchRequest);
        if (result.Status === 200 && result.Body) {
            const response = JSON.parse(result.Body) as OneDriveSharepointIdsResponse;
            if (!!response?.sharepointIds) {
                return {
                    ListId: response.sharepointIds.listId,
                    UniqueId: response.sharepointIds.listItemUniqueId,
                    SiteId: response.sharepointIds.siteId,
                    WebId: response.sharepointIds.webId,
                };
            }
        }
    } catch (error) {
        trace.warn(
            `Something went wrong while calling fetchDataProviderResourceOperation: ${error}`
        );
    }

    return null;
}

interface OneDriveSharepointIdsResponse {
    sharepointIds: {
        listId: string;
        listItemUniqueId: string;
        siteId: string;
        webId: string;
    };
}
